import React from "react";
import { TaskCardView } from "./view";
import { styles } from "./styles";

export class TaskCard extends React.Component {
  render() {
    return <TaskCardView {...this.props} styles={styles} />;
  }
}
